// src/config/dynamicListConfig.js

import {
  getAllCategoryType,
  getCategoryTypeById,
  getAllUserCategory,
  createCategoryType,
  getAllAdminCategory,
  getAllAdminLevel,
  getCategoryAdminById,
  updateCategoryType,
  createCategoryAdmin,
  updateAdminCategoryType,
 
} from "../services/superadminService/CategoreyType";
import AddCategoryModal from "../admin/admincomponent/categoryType/AddCategoryModal";
import CategoryUpdateModal from "../admin/admincomponent/categoryType/CategoryUpdateModal";
import ViewCategoryModal from "../admin/admincomponent/categoryType/ViewCategoryModal";



export const categoryTypeConfig  = {
  "user-category-type": {
    title: "User Category",
    fetchListApi: getAllCategoryType,
    fetchSelectListApi:getAllUserCategory,
    fetchByIdApi: getCategoryTypeById,
    fetchCreateApi:createCategoryType,
    fetchUpdate:updateCategoryType,
    categoryIdField: "user_category_main_id", 
    categorySelectKey: "main_category_name",
     tableHeaders: ["Sr.No", "Category Name", "Parent Category", "Slug", "Status", "Date", "Action"],
     viewTitle: ["Category Name", "Parent Category","Slug", "Status"],
     categoryLabel: "Select Main Category",
     CategoryOptions: [
      { id: 1, main_category_name: "Individual" },
      { id: 2, main_category_name: "Institute" },
    ],
  },
  "admin-category-type": {
    title: "Admin Category",
    fetchListApi: getAllAdminCategory,
    fetchSelectListApi:getAllAdminLevel,
    fetchByIdApi: getCategoryAdminById,
    fetchCreateApi:createCategoryAdmin,
    fetchUpdate:updateAdminCategoryType,
    categoryIdField: "user_level_id", 
     categorySelectKey: "user_level_name",
      categoryLabel: "Admin Category Level",
     tableHeaders: ["Sr.No", "Admin Category Name","Admin Category Level", "Slug", "Status", "Date", "Action"],
      viewTitle: ["Admin Category Name", "Admin Category Level","Slug", "Status"],
      CategoryOptions: [
      { id: 1, main_category_name: "Admin Mode" },
      { id: 2, main_category_name: "Subadmin Mode" },
    ],
  },
};
